import React from 'react'

const FormSubmitButton = ({
  buttonLabel = 'Log In',
  type = "submit"
}) => {
  return (
    <div>
      <button
        type={type}
        className="w-full px-4 py-2 text-white bg-[#85325f]  hover:bg-[#85325f]/80 outline-none"
      >
        {buttonLabel}
      </button>
    </div>
  )
}

export default FormSubmitButton